/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <section class="my-profile-page with-loader-absolute">
    <div class="account-content">
      <div class="account-content__header">
        <div class="content-title">
          <p class="subtitle" v-html="$t('returns_subtitle', currentUser)" v-show="currentUser"/>
        </div>
      </div>
      <div class="account-content__body">
        <rma-list :items="items"/>
      </div>
      <div class="account-content__footer">
        <button type="button" class="btn btn-primary" :to="{ name: 'newReturns' }">{{ $t('return_new') }}</button>
      </div>
    </div>
    <absolute-loader :showLoader="!currentUser || rmaCall" mode="fixed"></absolute-loader>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'
import Rma from '@/services/Rma'
import RmaList from 'theme/components/MyAccount/Rma/List'

export default {
  data: () => ({
    rmaCall: false,
    items: []
  }),
  computed: {
    ...mapState({
      currentUser: state => state.userAdmin.token
    })
  },
  beforeMount () {
    if (process.client) {
      return this.$store.commit('ui/setHeaderPageTitle', 'route.my-returns')
    }
  },
  mounted () {
    this.list()
  },
  methods: {
    list () {
      const _this = this
      this.rmaCall = true
      Rma.list({
        token: this.$store.state.userAdmin.token,
        storeViewCode: this.$store.state.ui.storeViewCode
      }).then(items => {
        _this.items = items
        _this.rmaCall = false
      })
    }
  },
  components: {
    AbsoluteLoader,
    RmaList
  }
}
</script>
